//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { ButtonControl } from '@book24/ui-components';
import Icon from '@/js/vue/Icon';

export default {
  name: 'PartnerLinkCopyBtn',
  components: {
    ButtonControl,
    Icon,
  },
  props: {
    copyValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isCopied: false,
    };
  },
  methods: {
    copyText(value) {
      if (value) {
        const tempInput = document.createElement('input');
        tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        this.isCopied = true;
      }
    },
  },
};
